var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 464.66 191.59",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "Arrow3",
    overflow: "visible",
    markerHeight: 7,
    markerWidth: 4.2071066,
    orient: "auto-start-reverse",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 4.2071068 7"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 .125 0)",
    d: "m3-3-3 3 3 3",
    fill: "none",
    stroke: "context-stroke",
    strokeLinecap: "round"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.8824 0 0 1.8824 15.604 3.9249)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 10.642 7.3052)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "axis-line",
    x2: 330,
    y1: 300,
    y2: 300,
    strokeWidth: "2px"
  }), /*#__PURE__*/React.createElement("line", {
    className: "axis-line",
    y2: 300,
    strokeWidth: "2px"
  }), /*#__PURE__*/React.createElement("text", {
    className: "plot-title",
    x: 165,
    y: -15,
    textAnchor: "middle"
  }, "Experimental lipid profile"), /*#__PURE__*/React.createElement("line", {
    className: "axis-grid",
    y2: 300,
    opacity: 0.5,
    stroke: "#c0c0bb"
  }), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    y: 303,
    dy: "0.70999998em",
    textAnchor: "middle"
  }, "58"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "axis-grid",
    y2: 300,
    opacity: 0.5,
    stroke: "#c0c0bb"
  }), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    y: 303,
    dy: "0.70999998em",
    textAnchor: "middle"
  }, "60")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "axis-grid",
    y2: 300,
    opacity: 0.5,
    stroke: "#c0c0bb"
  }), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    y: 303,
    dy: "0.70999998em",
    textAnchor: "middle"
  }, "62")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(99)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "axis-grid",
    y2: 300,
    opacity: 0.5,
    stroke: "#c0c0bb"
  }), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    y: 303,
    dy: "0.70999998em",
    textAnchor: "middle"
  }, "64")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(132)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "axis-grid",
    y2: 300,
    opacity: 0.5,
    stroke: "#c0c0bb"
  }), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    y: 303,
    dy: "0.70999998em",
    textAnchor: "middle"
  }, "66")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(165)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "axis-grid",
    y2: 300,
    opacity: 0.5,
    stroke: "#c0c0bb"
  }), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    y: 303,
    dy: "0.70999998em",
    textAnchor: "middle"
  }, "68")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(198)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "axis-grid",
    y2: 300,
    opacity: 0.5,
    stroke: "#c0c0bb"
  }), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    y: 303,
    dy: "0.70999998em",
    textAnchor: "middle"
  }, "70")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(231)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "axis-grid",
    y2: 300,
    opacity: 0.5,
    stroke: "#c0c0bb"
  }), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    y: 303,
    dy: "0.70999998em",
    textAnchor: "middle"
  }, "72")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "axis-grid",
    y2: 300,
    opacity: 0.5,
    stroke: "#c0c0bb"
  }), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    y: 303,
    dy: "0.70999998em",
    textAnchor: "middle"
  }, "74")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(297)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "axis-grid",
    y2: 300,
    opacity: 0.5,
    stroke: "#c0c0bb"
  }), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    y: 303,
    dy: "0.70999998em",
    textAnchor: "middle"
  }, "76")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(330)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "axis-grid",
    y2: 300,
    opacity: 0.5,
    stroke: "#c0c0bb"
  }), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    y: 303,
    dy: "0.70999998em",
    textAnchor: "middle"
  }, "78")), /*#__PURE__*/React.createElement("text", {
    className: "axis-label",
    x: 165,
    y: 335,
    textAnchor: "middle"
  }, "Carbon chain length / #"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,300)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "axis-grid",
    x2: 330,
    opacity: 0.5,
    stroke: "#c0c0bb"
  }), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    x: -3,
    dy: "0.31999999em",
    textAnchor: "end"
  }, "0")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,266.67)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "axis-grid",
    x2: 330,
    opacity: 0.5,
    stroke: "#c0c0bb"
  }), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    x: -3,
    dy: "0.31999999em",
    textAnchor: "end"
  }, "1")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,233.33)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "axis-grid",
    x2: 330,
    opacity: 0.5,
    stroke: "#c0c0bb"
  }), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    x: -3,
    dy: "0.31999999em",
    textAnchor: "end"
  }, "2")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,200)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "axis-grid",
    x2: 330,
    opacity: 0.5,
    stroke: "#c0c0bb"
  }), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    x: -3,
    dy: "0.31999999em",
    textAnchor: "end"
  }, "3")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,166.67)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "axis-grid",
    x2: 330,
    opacity: 0.5,
    stroke: "#c0c0bb"
  }), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    x: -3,
    dy: "0.31999999em",
    textAnchor: "end"
  }, "4")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,133.33)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "axis-grid",
    x2: 330,
    opacity: 0.5,
    stroke: "#c0c0bb"
  }), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    x: -3,
    dy: "0.31999999em",
    textAnchor: "end"
  }, "5")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,100)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "axis-grid",
    x2: 330,
    opacity: 0.5,
    stroke: "#c0c0bb"
  }), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    x: -3,
    dy: "0.31999999em",
    textAnchor: "end"
  }, "6")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,66.667)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "axis-grid",
    x2: 330,
    opacity: 0.5,
    stroke: "#c0c0bb"
  }), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    x: -3,
    dy: "0.31999999em",
    textAnchor: "end"
  }, "7")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,33.333)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "axis-grid",
    x2: 330,
    opacity: 0.5,
    stroke: "#c0c0bb"
  }), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    x: -3,
    dy: "0.31999999em",
    textAnchor: "end"
  }, "8")), /*#__PURE__*/React.createElement("line", {
    className: "axis-grid",
    x2: 330,
    opacity: 0.5,
    stroke: "#c0c0bb"
  }), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    x: -3,
    dy: "0.31999999em",
    textAnchor: "end"
  }, "9"), /*#__PURE__*/React.createElement("text", {
    className: "axis-label",
    transform: "rotate(-90,57.5,92.5)",
    textAnchor: "middle"
  }, "Double bonds / #"), /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 33,
    cy: 233.33,
    r: 1.2662,
    fill: "#ff794d",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 33,
    cy: 200,
    r: 1.3373,
    fill: "#ff794d",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 66,
    cy: 200,
    r: 4.4088,
    fill: "#ffff4d",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 82.5,
    cy: 200,
    r: 1.7211,
    fill: "#bcff4d",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 99,
    cy: 200,
    r: 5.8688,
    fill: "#79ff4d",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 99,
    cy: 166.67,
    r: 9.5447,
    fill: "#79ff4d",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 115.5,
    cy: 200,
    r: 2.5376,
    fill: "#4dff63",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 115.5,
    cy: 166.67,
    r: 4.3418,
    fill: "#4dff63",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#4dffa6"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 132,
    cy: 233.33,
    r: 1.6609,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 132,
    cy: 200,
    r: 5.8632,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 132,
    cy: 166.67,
    r: 15.404,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 132,
    cy: 133.33,
    r: 6.8104,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 132,
    cy: 100,
    r: 0.9945,
    opacity: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#4dffe9"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 148.5,
    cy: 233.33,
    r: 0.83727,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 148.5,
    cy: 200,
    r: 2.7829,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 148.5,
    cy: 166.67,
    r: 7.0716,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 148.5,
    cy: 133.33,
    r: 3.446,
    opacity: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#4dd2ff"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 165,
    cy: 233.33,
    r: 2.1037,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 165,
    cy: 200,
    r: 4.0145,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 165,
    cy: 166.67,
    r: 20,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 165,
    cy: 133.33,
    r: 12.02,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 165,
    cy: 100,
    r: 4.7661,
    opacity: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#4d8fff"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 181.5,
    cy: 200,
    r: 2.7502,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 181.5,
    cy: 166.67,
    r: 7.421,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 181.5,
    cy: 133.33,
    r: 4.7536,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 181.5,
    cy: 100,
    r: 1.9247,
    opacity: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#4d4dff"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 198,
    cy: 200,
    r: 1.6249,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 198,
    cy: 166.67,
    r: 17.124,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 198,
    cy: 133.33,
    r: 13.239,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 198,
    cy: 100,
    r: 7.028,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 198,
    cy: 66.667,
    r: 2.064,
    opacity: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#8f4dff"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 214.5,
    cy: 200,
    r: 0.87165,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 214.5,
    cy: 166.67,
    r: 4.3162,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 214.5,
    cy: 133.33,
    r: 3.8282,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 214.5,
    cy: 100,
    r: 2.163,
    opacity: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#d24dff"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 231,
    cy: 166.67,
    r: 6.6536,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 231,
    cy: 133.33,
    r: 8.2771,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 231,
    cy: 100,
    r: 5.9177,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 231,
    cy: 66.667,
    r: 2.7498,
    opacity: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ff4da6"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 264,
    cy: 100,
    r: 1.8699,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 264,
    cy: 66.667,
    r: 1.5765,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dots inactive",
    cx: 264,
    cy: 33.333,
    r: 1.6521,
    opacity: 0.9
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 149.28 7.3052)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "axis-line",
    x2: 310,
    y1: 300,
    y2: 300,
    strokeWidth: "2px"
  }), /*#__PURE__*/React.createElement("line", {
    className: "axis-line",
    y2: 300,
    strokeWidth: "2px"
  }), /*#__PURE__*/React.createElement("text", {
    className: "plot-title",
    x: 155,
    y: -15,
    textAnchor: "middle"
  }, "Modeled fatty acid profile"), /*#__PURE__*/React.createElement("g", {
    textAnchor: "end"
  }, /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    transform: "rotate(-30,577.58,121)",
    dy: "0.70999998em"
  }, "FA 14:0"), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    transform: "rotate(-30,592.92,63.725)",
    dy: "0.70999998em"
  }, "FA 16:1"), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    transform: "rotate(-30,608.27,6.4512)",
    dy: "0.70999998em"
  }, "FA 17:0"), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    transform: "rotate(-30,623.62,-50.823)",
    dy: "0.70999998em"
  }, "FA 17:1"), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    transform: "rotate(-30,638.96,-108.1)",
    dy: "0.70999998em"
  }, "FA 18:0"), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    transform: "rotate(-30,654.31,-165.37)",
    dy: "0.70999998em"
  }, "FA 18:1"), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    transform: "rotate(-30,669.66,-222.65)",
    dy: "0.70999998em"
  }, "FA 18:2"), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    transform: "rotate(-30,685,-279.92)",
    dy: "0.70999998em"
  }, "FA 18:3"), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    transform: "rotate(-30,700.35,-337.19)",
    dy: "0.70999998em"
  }, "FA 20:2"), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    transform: "rotate(-30,715.7,-394.47)",
    dy: "0.70999998em"
  }, "FA 20:3")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,300)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "axis-grid",
    x2: 310,
    opacity: 0.5,
    stroke: "#c0c0bb"
  }), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    x: -3,
    dy: "0.31999999em",
    textAnchor: "end"
  }, "0%")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,266.67)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "axis-grid",
    x2: 310,
    opacity: 0.5,
    stroke: "#c0c0bb"
  }), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    x: -3,
    dy: "0.31999999em",
    textAnchor: "end"
  }, "5%")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,233.33)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "axis-grid",
    x2: 310,
    opacity: 0.5,
    stroke: "#c0c0bb"
  }), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    x: -3,
    dy: "0.31999999em",
    textAnchor: "end"
  }, "10%")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,200)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "axis-grid",
    x2: 310,
    opacity: 0.5,
    stroke: "#c0c0bb"
  }), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    x: -3,
    dy: "0.31999999em",
    textAnchor: "end"
  }, "15%")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,166.67)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "axis-grid",
    x2: 310,
    opacity: 0.5,
    stroke: "#c0c0bb"
  }), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    x: -3,
    dy: "0.31999999em",
    textAnchor: "end"
  }, "20%")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,133.33)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "axis-grid",
    x2: 310,
    opacity: 0.5,
    stroke: "#c0c0bb"
  }), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    x: -3,
    dy: "0.31999999em",
    textAnchor: "end"
  }, "25%")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,100)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "axis-grid",
    x2: 310,
    opacity: 0.5,
    stroke: "#c0c0bb"
  }), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    x: -3,
    dy: "0.31999999em",
    textAnchor: "end"
  }, "30%")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,66.667)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "axis-grid",
    x2: 310,
    opacity: 0.5,
    stroke: "#c0c0bb"
  }), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    x: -3,
    dy: "0.31999999em",
    textAnchor: "end"
  }, "35%")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,33.333)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "axis-grid",
    x2: 310,
    opacity: 0.5,
    stroke: "#c0c0bb"
  }), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    x: -3,
    dy: "0.31999999em",
    textAnchor: "end"
  }, "40%")), /*#__PURE__*/React.createElement("line", {
    className: "axis-grid",
    x2: 310,
    opacity: 0.5,
    stroke: "#c0c0bb"
  }), /*#__PURE__*/React.createElement("text", {
    className: "tick-label",
    x: -3,
    dy: "0.31999999em",
    textAnchor: "end"
  }, "45%"), /*#__PURE__*/React.createElement("text", {
    className: "axis-label",
    transform: "rotate(-90,47.5,102.5)",
    textAnchor: "middle"
  }, "Probability / %"), /*#__PURE__*/React.createElement("rect", {
    className: "inactive",
    x: 3.0693,
    y: 286.79,
    width: 27.624,
    height: 13.209,
    fill: "#ffb14d"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "inactive",
    x: 33.762,
    y: 27.252,
    width: 27.624,
    height: 272.75,
    fill: "#dcff4d"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "inactive",
    x: 64.455,
    y: 297.96,
    width: 27.624,
    height: 2.0414,
    fill: "#6bff4d"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "inactive",
    x: 95.149,
    y: 281.29,
    width: 27.624,
    height: 18.706,
    fill: "#4dff66"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "inactive",
    x: 125.84,
    y: 299.32,
    width: 27.624,
    height: 0.67561,
    fill: "#4dff9f"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "inactive",
    x: 156.53,
    y: 6.227,
    width: 27.624,
    height: 293.77,
    fill: "#4dffd7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "inactive",
    x: 187.23,
    y: 245.65,
    width: 27.624,
    height: 54.347,
    fill: "#4defff"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "inactive",
    x: 217.92,
    y: 297.02,
    width: 27.624,
    height: 2.9788,
    fill: "#4db6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "inactive",
    x: 248.61,
    y: 294.21,
    width: 27.624,
    height: 5.785,
    fill: "#c44dff"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "inactive",
    x: 279.31,
    y: 296.89,
    width: 27.624,
    height: 3.1126,
    fill: "#fd4dff"
  }), "))}\n  "), /*#__PURE__*/React.createElement("path", {
    d: "m104 48.039h22.142",
    markerEnd: "url(#Arrow3)",
    className: "results-arrow"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResults);
export default __webpack_public_path__ + "static/media/results.11de032379d79b6db09a056e4a3a914c.svg";
export { ForwardRef as ReactComponent };